var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_csr_warning)?_c('div',{staticClass:"csr-header-warning text-center"},[_vm._v("\n    "+_vm._s(_vm.l.t('app.you-are-in-csr-mode', 'You are in CSR mode'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }